export function getNameInitials(name?: string | null) {
  // se non c'è il nome, inseriamo i trattini
  const names = name?.split(' ') ?? ['-', '-'];
  // se c'è un solo nome o più di 3,
  // prendiamo solo la prima lettera del primo nome che convertiamo in maiuscole
  if (names.length === 1 || names.length > 3)
    return names[0].trim().charAt(0).toUpperCase();
  // altrimenti prendiamo la prima lettera di ogni nome convertita in maiuscole
  // l'avatar di ant calcola automaticamente la dimensione del font
  return names
    .map(n => n.trim().charAt(0))
    .join('')
    .toUpperCase();
}
